import { useCallback, useMemo } from 'react';
import { useGoogleReCaptcha as useRealGoogleReCaptcha } from 'react-google-recaptcha-v3';

const useMockGoogleReCaptcha = () => {
  // Memoize the mock function so its reference is stable
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const executeRecaptcha = useCallback(async (_action: string) => {
    return Promise.resolve(Math.random().toString(36));
  }, []);
  return useMemo(() => ({ executeRecaptcha }), [executeRecaptcha]);
};

export function useAppGoogleReCaptcha() {
  const real = useRealGoogleReCaptcha();
  const mock = useMockGoogleReCaptcha();

  // Memoize the returned object to avoid unstable references
  return useMemo(() => (process.env.REACT_APP_USE_RECAPTCHA === 'true' ? real : mock), [
    real,
    mock,
  ]);
}
